import type { FC, ReactNode } from 'react'

import { createContext, useContext, useEffect, useState } from 'react'
import Lenis from 'lenis'

interface SmoothScrollProps {
    children: ReactNode
}

const LenisContext = createContext<Lenis | null>(null)

export const SmoothScroll: FC<SmoothScrollProps> = ({ children }): ReactNode => {
    const [lenis, setLenis] = useState<Lenis | null>(null)

    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

        const instance = new Lenis({
            lerp: 0.085,
            smoothWheel: true,
            wheelMultiplier: 0.95,
            autoRaf: true
        })

        setLenis(instance)

        return () => {
            instance.destroy()
            setLenis(null)
        }
    }, [])

    return (
        <LenisContext.Provider value={lenis}>
            {children}
        </LenisContext.Provider>
    )
}

export const useLenis = (): Lenis | null => {
    return useContext(LenisContext)
}
